module.exports = __webpack_public_path__ + "static/media/activerse_logo_horizontal.77dfafd6.svg";